import clsx from "clsx";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

interface Props {
    excelExport: () => void
    pageName: string
}

const ExcelExport = ({
    excelExport,
    pageName
}: Props) => {
    const auth = useSelector((state: RootState) => state.auth)

    return (
        <React.Fragment>
            {
                auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canExcel && (
                    <div className='m-0'>
                        <a
                            onClick={excelExport}
                            className={clsx('btn btn-sm btn-flex fw-bold bg-gray-200 btn-color-gray-700 btn-active-color-primary btn-active-light-primary')}
                        >
                            <i className='fa fa-download fs-6 color-gray-700 me-1' />
                            Excel
                        </a>
                    </div>
                )
            }
        </React.Fragment>
    )
}

export default ExcelExport;